import { fallbackImage } from './fallbackImage';

export { fallbackImage };

// Register directives globally if needed
export default {
  install(app: any) {
    app.directive('fallback-image', fallbackImage);
  }
};
